import { useDownloadCargoFileLazyQuery } from "../../../../gen/graphql/types";

import { downloadFile } from "../../../../utils/downloadFile";

export const useDownloadCargoFile = (cargoFileId: number) => {
  const [getData, { loading: isLoading, error }] =
    useDownloadCargoFileLazyQuery();

  const onDownload = () => {
    getData({
      variables: { id: cargoFileId },
      onCompleted: (data) => {
        if (data?.downloadCargoFile?.url) {
          downloadFile(data.downloadCargoFile.url);
        } else {
          console.error(error);
          alert("Failed to obtain download URL.");
        }
      },
    });
  };

  return {
    isLoading,
    onDownload,
  };
};
